import { createFileRoute } from '@tanstack/react-router';
import { OttoPilotLayout } from '@/components/OttoPilot';

export const Route = createFileRoute('/dev/OttoPilot/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <OttoPilotLayout basePath="/dev/OttoPilot" />;
}
